var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("embroideryCircleController", [
    "$scope","$sce","$window","embroideryCircleService","accountService","elasticService","urlService","cartService","loaderService", "storefrontApp.mainContext",
        function (
        $scope,$sce,$window,embroideryCircleService,accountService,elasticService,urlService,cartService,loaderService,storefrontAppMainContext
    ) {

        $scope.freebie_activeIndex = 0;
        $scope.isCircleMember = false;

        $scope.isTenurePromotionActive = false;
        if ($window.__env && $window.__env.IsTenurePromotionActive && $window.__env.TenurePromotionCreditMonths) {
            var m = $window.__env.TenurePromotionCreditMonths;
            $scope.isTenurePromotionActive = true;
            $scope.tenurePromoLabel = "+" + m + " free month" + (m > 1 ? "s" : "") + " bonus";
        }

        $scope.toggleAnswer = function (index) {
            $scope.freebie_activeIndex = $scope.freebie_activeIndex === index ? -1 : index;
        };

          //#region Common
        $scope.$watch(
            function () {
                return storefrontAppMainContext.customer;
            },
            function () {
                $scope.customer = storefrontAppMainContext.customer;
                if ($scope.customer && $scope.customer.email) {
                    $scope.GetClubMembershipInfo();
                }
            }
        );
        //#endregion

        $scope.getMembershipPlans = function () {
            embroideryCircleService.getMembershipPlans().then(function (response) {
                if (response && response.data) {
                    $scope.membershipPlans = response.data;
                    $scope.selectedPlan = response.data[0].planTenure.toString();
                    $scope.planToPurchase = response.data[0];
                    $scope.membershipPlans = $scope.membershipPlans.filter(function(plan) {
                        return plan.planId !== 'ED-Trial';
                    });
                }
            });
        }

        $scope.onTrailMembershipCheckout = function (selectedPlan) {
            if ($scope.customer && $scope.customer.contactId)
            {
                $window.location.href = "/embroidery-circle/trialcheckout";
            }
            else{
                $window.location.href = "/account/login?ReturnUrl=/embroidery-circle";
            }

        };

        $scope.GetClubMembershipInfo = function() {
            accountService
                .getCustomerMembershipDetails($scope.customer.contactId)
                .then(function (response) {
                    if (response && response.data) {
                        $scope.membership = response.data;
                        $scope.isCircleMember = true;
                        $scope.isCircleMemberActive = $scope.membership.isActive
                    }
                    else{
                        $scope.isCircleMember = false
                    }
                });
        }

        $scope.getMembershipPageContent = function(){
            embroideryCircleService.getMembershipPageContent().then(function (response) {
                if (response && response.data) {
                    $scope.membershipPageContent = response.data.package_content;

                    var filterContentBySection = function (section) {
                        return $scope.membershipPageContent.filter(function (content) {
                            return $sce.trustAsHtml(content.pageSection) == section;
                        });
                    };

                    $scope.membershipFreebies = filterContentBySection("freebies");
                    $scope.membershipDiscounts = filterContentBySection("discounts");
                    $scope.membershipCollection = filterContentBySection("collections");
                    $scope.membershipDigitizing = filterContentBySection("digitizing");
                    $scope.membershipGiveaways_temp = filterContentBySection("giveaways");
                }
                $scope.getFreebies();
            });
        }

        angular.element($window).bind("resize", function () {
            $scope.windowWidth = $window.innerWidth;
            $scope.getActiveItems('Packs');
            $scope.getActiveItems('Fonts');
        });

        $scope.getFreebies = function() {
            var productIds = [];
            accountService
                .getembroideryCircleFreebies()
                .then(function (response) {
                    if (response && response.data && response.data.length > 0) {
                        $scope.embroiderycircleFreebies = response.data;
                        $scope.embroiderycircleFreebies.forEach(
                            function (product) {
                            productIds.push(product.itemId.toLowerCase());
                            }
                        );
                        buildProducts(productIds);
                    }
                    else {
                        $scope.giveawayPacksMaster = angular.copy($scope.membershipGiveaways_temp);
                        $scope.handleGiveAwayFreebies();
                    }
                })
                .catch(function (error) {
                    $scope.giveawayPacksMaster = angular.copy($scope.membershipGiveaways_temp);
                    $scope.handleGiveAwayFreebies($scope.membershipGiveaways_temp);
                });
        }

        function buildProducts(productIds) {
            var items = [];
            elasticService
                .getElasticData(
                    elasticService.buildProductByIdsRequest(
                        angular.toJson(productIds)
                    )
                )
                .then(function (response) {
                    if (response && response.data) {
                        $scope.elasticbuilddata = response.data.hits.hits;
                        response.data.hits.hits.forEach(function (res) {
                            var name = res._source.name;
                            var itemId = res._source.itemId;
                            var productDefinition = res._source.definitionName;
                            var imageUrl = urlService.getImageUrl({
                                definitionName: res._source.definitionName,
                                size: "large",
                                catalogId: res._source.catalog,
                                sku: res._source.productId,
                            });

                            items.push({
                                name: name.replace(/"/g, ""),
                                imageUrl: imageUrl,
                                productDefinition: productDefinition,
                                itemId: itemId,
                            });
                        });
                        if (items.length > 0) {
                            var designPacks = [];
                            var fonts = [];
                            items.forEach(function (item) {
                                if (item.productDefinition.toLowerCase() === "designpack") {
                                    designPacks.push(item);
                                } else if (item.productDefinition.toLowerCase() === "font") {
                                    fonts.push(item);
                                }
                            });

                            var membershipGiveaways = angular.copy($scope.membershipGiveaways_temp);
                            membershipGiveaways[0].content[0].samples = designPacks;
                            membershipGiveaways[0].content[1].samples = fonts;
                            $scope.giveawayPacksMaster = angular.copy(membershipGiveaways);
                        }
                        else {
                            $scope.giveawayPacksMaster = angular.copy($scope.membershipGiveaways_temp);
                        }

                        $scope.handleGiveAwayFreebies();
                    } else {
                        $scope.giveawayPacksMaster = angular.copy($scope.membershipGiveaways_temp);
                        $scope.handleGiveAwayFreebies();
                    }
                })
                .catch(function (error) {
                    $scope.giveawayPacksMaster = angular.copy($scope.membershipGiveaways_temp);
                    $scope.handleGiveAwayFreebies();
                });
        }

        $scope.handleGiveAwayFreebies = function(){
            if ($scope.giveawayPacksMaster.length > 0) {
                var giveawaysSection = $scope.giveawayPacksMaster [0];
                var giveawaysDetails = giveawaysSection.content;
                $scope.giveawaysHeader = {
                    "header": giveawaysSection.header,
                    "subtitle": giveawaysSection.subtitle
                };

                $scope.filteredPacks = giveawaysDetails.find(function (content) {
                    return content.title.toLowerCase().indexOf("packs") > 0;
                }) || {};

                $scope.filteredFonts = giveawaysDetails.find(function (content) {
                    return content.title.toLowerCase().indexOf("fonts") > 0;
                }) || {};

                $scope.giveawayPacksMaster = $scope.filteredPacks.samples ? $scope.filteredPacks.samples.map(function(font) {
                    return font.imageUrl || font;
                }) : [];
                $scope.giveawayFontsMaster = $scope.filteredFonts.samples ? $scope.filteredFonts.samples.map(function(pack) {
                    return pack.imageUrl || pack;
                }) : [];

                var visibleCount = $scope.getActiveCarousalLength();
                $scope.giveawayFonts = $scope.giveawayFontsMaster.slice( 0, visibleCount );
                $scope.giveawayPacks = $scope.giveawayPacksMaster.slice( 0, visibleCount );

                var activeCarousalLength = Number($scope.getActiveCarousalLength());
                $scope.activeGiveawayFontsMasterIndex = activeCarousalLength - 1;
                $scope.activeGiveawayPacksMasterIndex = activeCarousalLength - 1;
            }
        }

        $scope.getMembershipPlans();
        $scope.getMembershipPageContent();

        $scope.getActiveCarousalLength = function () {
            if ($scope.windowWidth < 767) {
                return 3;
            } else {
                return 4;
            }
        };

        $scope.activeGiveawayFontsMasterIndex = 0;
        $scope.activeGiveawayPacksMasterIndex = 0;

        $scope.onCarousalNavClick = function(direction, src) {
            var count = $scope.getActiveCarousalLength();
            if (direction == 'prev') {
                if (
                    $scope["activeGiveaway" + src + "MasterIndex"] - Number(count) + 1 > 0
                ) {
                    $scope["activeGiveaway" + src + "MasterIndex"] = $scope["activeGiveaway" + src + "MasterIndex"] - 1;
                    $scope['giveaway'+ src].pop();
                    $scope['giveaway'+ src].unshift(
                        $scope['giveaway'+ src + 'Master'][$scope["activeGiveaway" + src + "MasterIndex"] - Number(count) + 1 ]
                    );
                }
            } else if (direction == 'next') {
                if (
                    $scope["activeGiveaway" + src + "MasterIndex"] < $scope['giveaway'+ src + 'Master'].length - 1
                ) {
                    $scope["activeGiveaway" + src + "MasterIndex"] = $scope["activeGiveaway" + src + "MasterIndex"] + 1;
                    $scope['giveaway'+ src].splice(0, 1);
                    $scope['giveaway'+ src].push(
                        $scope['giveaway'+ src + 'Master'][$scope["activeGiveaway" + src + "MasterIndex"]]
                    );
                }
            }
        };

        $scope.getActiveItems = function (src) {
            if ($scope.getActiveCarousalLength() != $scope["giveaway" + src].length) {
                $scope["activeGiveaway" + src + "MasterIndex"] = $scope.getActiveCarousalLength() - 1;
                $scope["giveaway" + src] = $scope["giveaway" + src + "Master"].slice(
                    0, $scope.getActiveCarousalLength()
                );
                $scope.$apply();
            }
        };

        $scope.onJoinNowClick = function(planToCheckout){
            if (angular.isDefined(planToCheckout)) {
               loaderService.show();
                cartService.addMembershipCart(planToCheckout.planId,planToCheckout.planTenure).then(function(response){
                    if(response && response.data){
                        loaderService.hide();
                        $window.location.href = "/cart/checkout";
                    }
                    else{
                        loaderService.hide();
                        $window.location.href = "/account/login?ReturnUrl=/embroidery-circle";
                    }
                })
            }
            else {
                alert("Please select a valid Plan")
            }
        }

        $scope.scrollTo = function(){
            $window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        }

        $scope.scrollToSection = function(section){
            var element = document.getElementById(section);
            if (element) {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        }
        //#endregion
    }
]);
